import type { MailboxInfo } from 'owa-client-types';
import { isAccountFeatureEnabled } from 'owa-feature-flags';

export function isFrontierPublicUserEnabled(mailboxInfo: MailboxInfo): boolean {
    return isAccountFeatureEnabled('mon-copilot-dev-frontier', mailboxInfo);
}
